export default "../media/bg_work_1_large.7f3b5310206e3007474a3fe05cb810d7.jpeg";